import { BehaviorSubject, filter, first } from "rxjs";
import * as signalR from '@microsoft/signalr';

const suscribtion = 'notifications';
const broadcast = 'broadcast';

const connectedSource = new BehaviorSubject(false);
const notificationSource = new BehaviorSubject(null);

const connected$ = connectedSource.asObservable();
const notification$ = notificationSource.asObservable();

let connection;
const retryLimit = 5;
let retries = 0;

const connect = (url, jwt) => {
    connection = createConnection(url, jwt);
    connected$
        .pipe(first(), filter(isConnected => !isConnected))
        .subscribe((data) => {
            connection.start()
                .then(() => {
                    connectedSource.next(true);
                })
                .catch((e) => {
                    connectedSource.next(false);
                    setTimeout(() => {
                        if (retries <= retryLimit) {
                            connect();
                            retries++;
                        }
                    }, 5000);
                });
        });
}

const createConnection = (url, jwt) => {
    console.log('createConnection params: ', url, jwt);
    let _url = url + suscribtion;
    console.log('url: ', _url);
    return new signalR.HubConnectionBuilder()
        .withUrl(_url, {
            accessTokenFactory: () => jwt
        })
        .build();
}

const disconnect = () => {
    connected$
        .pipe(first(), filter(isConnected => isConnected))
        .subscribe(() => {
            connection.stop()
                .then(() => connectedSource.next(false))
                .catch(() => console.log('[Notification] service disconnected'));
        })
}

const start = (url, jwt) => {
    connect(url, jwt);
    connection.on('broadcastMessage', data => notificationSource.next(data));
    connection.onclose((error) => {
        setTimeout(() => {
            connectedSource.next(false);
            retries = 0;
            connect();
        }, 5000);
    });
}



export { connected$, notification$, start }